import dayjs from "dayjs";

export const headerConfig = (weekFilter = {}) => {
  const startDate = weekFilter?.startDate ? dayjs(weekFilter.startDate) : null;
  const endDate = weekFilter?.endDate ? dayjs(weekFilter.endDate) : null;

  const weekLabel =
    startDate && endDate
      ? `For the Week (${startDate.format("DD MMM")} - ${endDate.format(
          "DD MMM"
        )})`
      : "For the Week";

  const monthLabel = startDate
    ? `For the Month (${startDate.format("MMMM")})`
    : "For the Month";

  const yearLabel = startDate ? `YTD (${startDate.format("YYYY")})` : "YTD";

  return [
    {
      id: "particular",
      label: "Departments",
    },
    {
      id: "weekly",
      label: weekLabel,
      background: "#D0E9FA",
      columns: [
        {
          id: "openedCount",
          label: "Open",
          render: (row) =>
            row?.weekly?.find((x) => x.id === "openedCount")?.value ?? "-",
        },
        {
          id: "resolvedCount",
          label: "Closed",
          render: (row) =>
            row?.weekly?.find((x) => x.id === "resolvedCount")?.value ?? "-",
        },
        {
          id: "avgTTR",
          label: "Avg TAT",
          render: (row) =>
            row?.weekly?.find((x) => x.id === "avgTTR")?.value ?? "-",
        },
      ],
    },
    {
      id: "monthly",
      label: monthLabel,
      background: "#A9D3F5",
      columns: [
        {
          id: "openedCount",
          label: "Open",
          render: (row) =>
            row?.monthly?.find((x) => x.id === "openedCount")?.value ?? "-",
        },
        {
          id: "resolvedCount",
          label: "Closed",
          render: (row) =>
            row?.monthly?.find((x) => x.id === "resolvedCount")?.value ?? "-",
        },
        {
          id: "avgTTR",
          label: "Avg TAT",
          render: (row) =>
            row?.monthly?.find((x) => x.id === "avgTTR")?.value ?? "-",
        },
      ],
    },
    {
      id: "yearly",
      label: yearLabel,
      background: "#7CB9E8",
      columns: [
        {
          id: "openedCount",
          label: "Open",
          render: (row) =>
            row?.yearly?.find((x) => x.id === "openedCount")?.value ?? "-",
        },
        {
          id: "resolvedCount",
          label: "Closed",
          render: (row) =>
            row?.yearly?.find((x) => x.id === "resolvedCount")?.value ?? "-",
        },
        {
          id: "avgTTR",
          label: "Avg TAT",
          render: (row) =>
            row?.yearly?.find((x) => x.id === "avgTTR")?.value ?? "-",
        },
      ],
    },
  ];
};
